export default __webpack_public_path__ + "static/media/aea7d39df5bf92af.a02a55fff9aff091c4f8ae894e98ab0e.svg";